<div class="ui-g card statsbox statsbox-{{ colour || 'green' }}">
  <div class="ui-g-3">
    <span class="statsbox-icon">{{ colour == 'green' ? 'check_circle' : 'report' }}</span>
  </div>
  <div class="ui-g-9 statsbox-text">
    <span class="statistics-name">{{ description }}</span>
    <span class="statistics-count">{{ amount }}</span>
  </div>
</div>
